export default __webpack_public_path__ + "static/media/copy-icon.37070362.svg";